<template>
  <div>
    <div v-if="!process">
      <Loading />
    </div>
    <b-modal  id="modal-register"
              ref="modal"
              size="md"
              centered
              hide-footer
              hide-header   
              content-class="rounded-0"   
              no-stacking 
    > 
      <form ref="form" @submit.stop.prevent="handleSubmit" v-if="process" class="font-k2d">
        <b-row class="mt-3">
          <b-col class="text-center">
            <b-img src="../assets/img/logo-V2-2022.png" class="w-25"></b-img>
            <h4 class="mt-3">สมัครสมาชิก</h4>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-col class="col-6">
            <b-form-group label="ชื่อ">
              <b-form-input type="text"
                            id="firstname"
                            v-model="firstname"
                            :state="firstnameState"
                            class="input-sign"
                            autocomplete="off"
              ></b-form-input>
              <b-form-invalid-feedback :state="firstnameState">
                <b-icon icon="x"></b-icon> กรุณากรอกชื่อ (ไม่ต้องมีคำนำหน้าชื่อ)
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="firstnameState">
                <b-icon icon="check"></b-icon> ถูกต้อง
              </b-form-valid-feedback>
            </b-form-group>
          </b-col>
            
          <b-col class="col-6">
            <b-form-group label="นามสกุล">
              <b-form-input type="text"
                            id="lastname"
                            v-model="lastname"
                            :state="lastnameState"
                            class="input-sign"
                            autocomplete="off"
              ></b-form-input>
              <b-form-invalid-feedback :state="lastnameState">
                <b-icon icon="x"></b-icon> กรุณากรอกนามสกุล
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="lastnameState">
                <b-icon icon="check"></b-icon> ถูกต้อง
              </b-form-valid-feedback>
            </b-form-group>
          </b-col>
            
          <b-col class="col-6">
            <b-form-group label="อีเมล (ที่สามารถใช้งานได้)">
              <b-form-input type="email"
                            id="email"
                            v-model="email"
                            :state="emailState"
                            class="input-sign"
                            autocomplete="off"
              ></b-form-input>
              <b-form-invalid-feedback :state="emailState">
                <b-icon icon="x"></b-icon> กรุณากรอกอีเมลให้ถูกต้อง
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="emailState">
                <b-icon icon="check"></b-icon> ถูกต้อง
              </b-form-valid-feedback>
            </b-form-group>
          </b-col>

          <b-col class="col-6">
            <b-form-group label="เบอร์โทรศัพท์ (ที่สามารถติดต่อได้)">
              <b-form-input type="number"
                            id="phone"
                            v-model="phone"
                            :state="phoneState"
                            @keyup="phoneLength"
                            class="input-sign"
                            autocomplete="off"
              ></b-form-input>
              <b-form-invalid-feedback :state="phoneState">
                <b-icon icon="x"></b-icon> กรุณากรอกเบอร์โทรศัพท์ 10 หลัก
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="phoneState">
                <b-icon icon="check"></b-icon> ถูกต้อง
              </b-form-valid-feedback>
            </b-form-group>
          </b-col>
            
          <b-col class="col-6">
            <b-form-group label="รหัสผ่าน">
              <b-form-input type="password"
                            id="password"
                            v-model="password"
                            :state="passwordState"
                            class="input-sign"
                            autocomplete="off"
              ></b-form-input>
              <b-form-invalid-feedback :state="passwordState">
                <b-icon icon="x"></b-icon> กรุณากรอกรหัสผ่าน อย่างน้อย 8 หลัก
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="passwordState">
                <b-icon icon="check"></b-icon> ถูกต้อง
              </b-form-valid-feedback>
            </b-form-group>
          </b-col>
            
          <b-col class="col-6">
            <b-form-group label="รหัสผ่าน อีกครั้ง">
              <b-form-input type="password"
                            id="password2"
                            v-model="password2"
                            :state="password2State"
                            class="input-sign"
                            autocomplete="off"
              ></b-form-input>
              <b-form-invalid-feedback :state="password2State">
                <b-icon icon="x"></b-icon> รหัสผ่านไม่ตรงกัน
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="password2State">
                <b-icon icon="check"></b-icon> รหัสผ่านตรงกัน
              </b-form-valid-feedback>
            </b-form-group>
          </b-col>
            
          <b-col class="col-6">
            <b-form-group label="เลือกประเภท">
              <b-form-select
                v-model="animal"
                :options="animals"
                name="animal-group"
                @change="viewFarmActive()"
              ></b-form-select>
            </b-form-group>
          </b-col>
            
          <b-col class="col-6">
            <b-form-group label="เลือกสิทธิ์เข้าใช้งาน">
              <b-form-select 
                v-model="role" 
                :options="roles"
                @change="changeRole(role)"
              ></b-form-select>
            </b-form-group>
          </b-col>
            
          <b-col class="col-12">
            <b-form-group label="เลือกฟาร์ม">
              <b-form-select v-model="farm" 
              :options="farms"
              :state="farmState"
              :disabled="admin"
              ></b-form-select>
              <b-form-invalid-feedback :state="farmState">
                <b-icon icon="x"></b-icon> กรุณาเลือกฟาร์ม
              </b-form-invalid-feedback>
              <b-form-valid-feedback :state="farmState">
                <b-icon icon="check"></b-icon> ถูกต้อง
              </b-form-valid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-3">
          <b-col class="text-center">
            <b-button type="submit" variant="outline-primary" :disabled="!completeState" pill>ลงทะเบียน</b-button>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </div>
</template>

<script>
  import Loading from '@/components/Loading.vue'

  export default {
    components: {
      Loading
    },
    data() {
      return {
        admin: false,
        process: true,
        firstname: '',
        lastname: '',
        email: '',
        phone: '',
        password: '',
        password2: '',
        farm: 0,
        farms: [
          {value: null, text: '-- เลือกฟาร์ม --'}
        ],
        animal: "",
        animals: [
          {value: "", text: 'สัตว์บก'},
          {value: "/poultry", text: 'สัตว์ปีก'},
          // {value: 3, text: 'สัตว์น้ำ'}
        ],
        role: 3,
        roles: [
          {value: 1, text: 'Admin'},
          {value: 2, text: 'User'},
          {value: 3, text: 'Monitoring'}
        ],
      }
    },
    computed: {
      firstnameState() {
        return this.firstname != ''
      },
      lastnameState() {
        return this.lastname != ''
      },
      emailState() {
        // return this.email.length != '' && /^\w+([.]?\w+)*@\w+([.]?\w+)*(\.\w{2,24})+$/.test(this.email)
        return this.email.length != ''
      },
      phoneState() {
        return this.phone.length == 10
      },
      passwordState() {
        return this.password.length >= 8 && this.password.length <= 15
      },
      password2State() {
        return this.password == this.password2 && this.password2 != ''
      },
      farmState() {
        if(this.role == 1) {
          return true
        }
        else {
          return this.farm != null
        }
      },
      completeState() {
        return this.firstnameState && this.lastnameState && this.emailState && this.phoneState && this.passwordState && this.password2State && this.farmState
      },
    },
    mounted() {
      this.viewFarmActive()
    },
    methods: {
      changeRole(role) {
        if(role == 1) {
          this.farm = 0
          this.admin = true
        }
        else {
          this.farm = null
          this.admin = false
        }
      },
      phoneLength() {
        if(this.phone.length > 10) {
          let str = this.phone
          let res = str.split("");
          res.shift();
          this.phone = res.join("");
        }
      },
      viewFarmActive() {
        this.farm = null
        this.farms = [{ value: null, text: '-- เลือกฟาร์ม --' }]
        this.$store.dispatch('viewFarmActive', {
          animal: this.animal
        })
        .then(response => {
          if(response.data.success == 1 && response.data.data.length != 0) {
            for(let i in response.data.data) {
              this.farms.push(
                {value: response.data.data[i].farm_id, text: response.data.data[i].name_th}
              )
            }          
          }
        })
      },
      handleSubmit(e) {
        e.preventDefault()
        this.process = false
        this.$bvModal.hide('modal-register')
        this.$store.dispatch('Register', {
          animal: this.animal,
          username: this.email,
          password: this.password,
          first_name: this.firstname,
          last_name: this.lastname,
          mobile: this.phone,
          farm_id: this.farm,
          role: this.role
        })
        .then(response => {
          if(response.data.success == 1) {
            this.process = true
            this.alertResult(`ลงทะเบียนสำเร็จ!`, response.data.message, `success`)
            // Checkbox is true
            // เพิ่ม Register iFarm
          }
          else{
            this.process = true
            this.alertResult(`ลงทะเบียน ไม่สำเร็จ!`, response.data.message, `danger`)
          }
        })
        .catch(error => {
          console.log(error)
        })
      },
      // เพิ่ม Register iFarm      
      // this.data = {
      //   email: this.email,
      //   password: this.password,
      //   firstname: this.firstname,
      //   lastname: this.lastname,
      //   farm_id: this.farm_id,
      //   phone: this.phone,
      //   role: this.role,
      //   group: this.group
      // }
      // this.$store.dispatch('Register', {
      //   body: this.data
      // })
      alertResult(title, body, variant) {
        this.$bvToast.toast(body, {
          title: title,
          autoHideDelay: 5000,
          appendToast: false,
          variant: variant,
          toaster: "b-toaster-bottom-right",
          solid: true,
        });
      },
    }
  }
</script>

<style>
</style>